import { api } from './api';

export interface TutorTopicSummary {
  nodeId: number;
  label: string;
  questionCount: number;
}

export interface TutorTestSummary {
  id: number;
  courseId: number;
  name: string;
  scheduledDate: string;
  randomizationMode: 'SHARED' | 'PER_STUDENT';
  effectiveQuestionCount: number;
  timeLimitMinutes: number | null;
  topicCount: number;
  totalPoolSize: number;
  attemptCount: number;
  warnings: string[];
  createdAt: string;
}

export interface TutorTestDetail {
  id: number;
  courseId: number;
  name: string;
  scheduledDate: string;
  randomizationMode: 'SHARED' | 'PER_STUDENT';
  effectiveQuestionCount: number;
  timeLimitMinutes: number | null;
  totalPoolSize: number;
  topics: TutorTopicSummary[];
  createdAt: string;
}

export interface CreateTestRequest {
  name: string;
  scheduledDate: string;
  topicNodeIds: number[];
  randomizationMode: 'SHARED' | 'PER_STUDENT';
  questionCount: number;
  timeLimitMinutes?: number | null;
}

export interface UpdateTestRequest {
  name?: string;
  scheduledDate?: string;
}

export const listTests = async (courseId: number): Promise<TutorTestSummary[]> => {
  const res = await api.get<{ data: TutorTestSummary[] }>(`/api/tutor/courses/${courseId}/tests`);
  return res.data.data;
};

export const getTest = async (courseId: number, testId: number): Promise<TutorTestDetail> => {
  const res = await api.get<{ data: TutorTestDetail }>(`/api/tutor/courses/${courseId}/tests/${testId}`);
  return res.data.data;
};

export const createTest = async (courseId: number, request: CreateTestRequest): Promise<TutorTestDetail> => {
  const res = await api.post<{ data: TutorTestDetail }>(`/api/tutor/courses/${courseId}/tests`, request);
  return res.data.data;
};

export const updateTest = async (
  courseId: number,
  testId: number,
  request: UpdateTestRequest,
): Promise<TutorTestDetail> => {
  const res = await api.patch<{ data: TutorTestDetail }>(
    `/api/tutor/courses/${courseId}/tests/${testId}`,
    request,
  );
  return res.data.data;
};

export const deleteTest = async (courseId: number, testId: number): Promise<void> => {
  await api.delete(`/api/tutor/courses/${courseId}/tests/${testId}`);
};
